/* eslint-disable no-console */
import _ from 'lodash';
import platform from 'platform';
import le from 'r7insight_js';
import config from '../../../config';

le.init({
    token: config.logging.logentries.token,
    region: 'us'
});

type LoggerOpts = {
    projectId?: string;
};

type LogParams = {
    message: string;
    data: $TSFixMe;
};

class Logger {
    defaultProps: $TSFixMe;

    constructor(readonly options: LoggerOpts = {}) {
        this.defaultProps = {
            browser: {
                name: platform.name,
                version: platform.version,
                osFamily: platform.os.family,
                osVersion: platform.os.version
            }
        } as $TSFixMe;
    }

    setDefaultProps(props: $TSFixMe, value: $TSFixMe) {
        if (_.isString(props) && !_.isUndefined(value)) {
            this.defaultProps[props] = value;
        } else if (_.isPlainObject(props) && _.isUndefined(value)) {
            _.assign(this.defaultProps, props);
        } else {
            console.error('illegal Logger.setDefaultProps invocation');
        }
    }

    log(message: LogParams['message'], data?: LogParams['data']) {
        const logData = this._logData(message, data);
        le.log(logData);
    }

    info(message: LogParams['message'], data?: LogParams['data']) {
        const logData = this._logData(message, data);
        le.info(logData);
    }

    warn(message: LogParams['message'], data?: LogParams['data']) {
        const logData = this._logData(message, data);
        le.warn(logData);
    }

    error(message: LogParams['message'], data?: LogParams['data']) {
        const logData = this._logData(message, data);
        le.error(logData);
    }

    debug(message: LogParams['message'], data?: LogParams['data']) {
        const logData = this._logData(message, data);
        le.info(logData);
    }

    _logData(message: LogParams['message'], data?: LogParams['data']) {
        const logData: $TSFixMe = {};
        if (_.isPlainObject(message)) {
            if (!_.isUndefined(data)) {
                console.error('illegal Logger.log invocation');
                return null;
            }
            if (_.size(message) === 0) {
                console.error('illegal Logger.log invocation');
                return null;
            }
            _.assign(logData, message, this._transformError(logData));
        } else {
            if (_.isString(message)) {
                logData.message = message;
            } else if (_.isUndefined(message)) {
                console.error('illegal Logger.log invocation');
                return null;
            } else {
                logData.message = _.toString(message);
            }
            if (_.isPlainObject(data)) {
                _.assign(logData, data);
                _.forEach(data, (value) => {
                    _.assign(logData, this._transformError(value));
                });
            } else if (data instanceof Error) {
                _.assign(logData, this._transformError(data));
            } else if (!_.isUndefined(data)) {
                console.error('illegal Logger.log invocation');
                return null;
            }
        }

        _.defaults(logData, { projectId: this.options.projectId }, this.defaultProps);

        if (config.env === 'local') {
            console.log(logData);
        }

        return logData;
    }

    _transformError(object: $TSFixMe) {
        if (object instanceof Error) {
            return { error: object.message, stack: object.stack };
        }
        return undefined;
    }
}
const logger = <Logger>{};

export const initLogger = (opts?: LoggerOpts) => {
    const loggerInstance = new Logger(opts);
    Object.setPrototypeOf(logger, loggerInstance);
};

export default logger;
